'use strict';
module.exports = require('./ConfirmationService.js');